import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import {
  getJourneyData,
  claimInitialGift,
  claimFinalGift,
} from '../../api/journeyService';

export const getJourneyThunk = createAsyncThunk(
  'journey/getJourney',
  async ({ companyId }, { rejectWithValue }) => {
    try {
      const response = await getJourneyData(companyId);
      return response;
    } catch (error) {
      return rejectWithValue(error.message || 'Failed to fetch journey');
    }
  }
);

export const claimInitialGiftThunk = createAsyncThunk(
  'journey/claimInitialGift',
  async ({ companyId }, { rejectWithValue }) => {
    try {
      const response = await claimInitialGift(companyId);
      return response;
    } catch (error) {
      return rejectWithValue(error.message || 'Failed to claim initial gift');
    }
  }
);

export const claimFinalGiftThunk = createAsyncThunk(
  'journey/claimFinalGift',
  async ({ companyId }, { rejectWithValue }) => {
    try {
      const response = await claimFinalGift(companyId);
      return response;
    } catch (error) {
      return rejectWithValue(error.message || 'Failed to claim final gift');
    }
  }
);

const initialState = {
  journey: {
    offerIssued: { dateIs: null, completed: false },
    offerAccepted: { dateIs: null, completed: false },
    initialReview: { dateIs: null, completed: false, count: 0 },
    initialGift: { dateIs: null, completed: false },
    discussion: { dateIs: null, completed: false },
    finalReview: { dateIs: null, completed: false, count: 0 },
    finalGift: { dateIs: null, completed: false },
    joiningDate: { dateIs: null, completed: false },
  },
  loading: false,
  error: null,
  claimingInitial: false,
  claimingFinal: false,
  claimError: null,
  showAddressModal: false,
  selectedGiftStage: null,
};

const journeySlice = createSlice({
  name: 'journey',
  initialState,
  reducers: {
    setAddressModalShow: (state, action) => {
      state.showAddressModal = action.payload.show;
      state.selectedGiftStage = action.payload.stage;
    },
    clearError: (state) => {
      state.error = null;
    },
    clearClaimError: (state) => {
      state.claimError = null;
    },
  },
  extraReducers: (builder) => {
    // Get Journey
    builder.addCase(getJourneyThunk.pending, (state) => {
      state.loading = true;
      state.error = null;
    });
    builder.addCase(getJourneyThunk.fulfilled, (state, action) => {
      state.loading = false;
      state.journey = action.payload;
    });
    builder.addCase(getJourneyThunk.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload;
    });

    // Claim Initial Gift
    builder.addCase(claimInitialGiftThunk.pending, (state) => {
      state.claimingInitial = true;
      state.claimError = null;
    });
    builder.addCase(claimInitialGiftThunk.fulfilled, (state) => {
      state.claimingInitial = false;
      state.showAddressModal = false;
      state.selectedGiftStage = null;
    });
    builder.addCase(claimInitialGiftThunk.rejected, (state, action) => {
      state.claimingInitial = false;
      state.claimError = action.payload;
    });

    // Claim Final Gift
    builder.addCase(claimFinalGiftThunk.pending, (state) => {
      state.claimingFinal = true;
      state.claimError = null;
    });
    builder.addCase(claimFinalGiftThunk.fulfilled, (state) => {
      state.claimingFinal = false;
      state.showAddressModal = false;
      state.selectedGiftStage = null;
    });
    builder.addCase(claimFinalGiftThunk.rejected, (state, action) => {
      state.claimingFinal = false;
      state.claimError = action.payload;
    });
  },
});

export const { setAddressModalShow, clearError, clearClaimError } =
  journeySlice.actions;

export default journeySlice.reducer;
